"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    ARIATemplate: {
        type: String,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dateInput: {
        type: Boolean,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: String,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    interval: {
        type: Number,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    parseFormats: {
        type: Array,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },
    timeFormat: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
};